import "./layout.css";
import "boxicons";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Admin_icon from "../assets/photo/admin.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronDown,
  faListUl,
  faBuildingColumns,
  faIndent,
  faFileInvoice,
  faFileCode,
  faUsersGear,
  faStore,
  faGear,
  faMobileScreen,
  faGlobe,
  faWrench,
  faLifeRing,
  faGaugeHigh,
  faEye,
  faPenToSquare,
  faEnvelope,
  faBell,
  faRing,
  faKey,
  faPuzzlePiece,
  faUniversalAccess,
  faTree,
  faMessage,
  faListCheck,
  faCircleInfo,
  faPeopleGroup,
  faVideo,
  faBars,
  faX,
  faUsers,
  faTruck,
  faWarehouse,
  faUserTie,
  faSquare,
  faClipboardUser,
  faExchangeAlt,
  faCircleLeft,
  faPersonCircleCheck,
  faPeopleArrows,
  faPeopleRobbery,
  faPerson,
  faFaceDizzy,
  faFaceGrinBeamSweat,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
export default function Layouts() {
  const pathname = window.location.pathname;
  const [render, setRender] = useState(true);
  const [headerToggle, setHeaderToggle] = useState(false);
  const [sidebar, setSidebar] = useState("");
  const [headerNavManu, setheaderNavManu] = useState(true);
  const [email, setEmail] = useState(null);
  const [isReportOpen, setIsReportOpen] = useState(false); // State for reports menu
  const [isStaffOpen, setIsStaffOpen] = useState(false);
  const [isAssetsOpen, setIsAssetsOpen] = useState(false);
  const [isExpenseOpen, setIsExpenseOpen] = useState(false);
  const [isDamageOpen, setIsDamageOpen] = useState(false);
  const [isVehiclesOpen, setIsVehiclesOpen] = useState(false);
  const [isOthersOpen, setIsOthersOpen] = useState(false);
  const [isSalaryOpen, setIsSalaryOpen] = useState(false);
  const [isLeavesOpen, setIsLeavesOpen] = useState(false);
  const [isLeasehistoryOpen, setIsLeasehistoryOpen] = useState(false);
  const [isTickethistoryOpen, setIsTickethistoryOpen] = useState(false);
  const [isJobhistoryOpen, setIsJobhistoryOpen] = useState(false);
  const [isLeadhistoryOpen, setIsLeadhistoryOpen] = useState(false);

  const userRole = localStorage.getItem("userRole");

  const toggleReportMenu = () => {
    setIsReportOpen(!isReportOpen); // Toggle the submenu visibility
  };
  const toggleStaffMenu = () => {
    setIsStaffOpen(!isStaffOpen); // Toggle submenu visibility
  };
  const toggleAssetsMenu = () => {
    setIsAssetsOpen(!isAssetsOpen); // Toggle submenu visibility
  };
  const toggleExpenseMenu = () => {
    setIsExpenseOpen(!isExpenseOpen); // Toggle submenu visibility
  };
  const toggleSalaryMenu = () => {
    setIsSalaryOpen(!isSalaryOpen); // Toggle submenu visibility
  };
  const toggleLeavesMenu = () => {
    setIsLeavesOpen(!isLeavesOpen); // Toggle submenu visibility
  };
  const toggleDamageMenu = () => {
    setIsDamageOpen(!isDamageOpen); // Toggle submenu visibility for DAMAGE
  };
  const toggleVehiclesMenu = () => {
    setIsVehiclesOpen(!isVehiclesOpen); // Toggle submenu visibility for VEHICLES
  };
  const toggleLeasehistoryMenu = () => {
    setIsLeasehistoryOpen(!isLeasehistoryOpen); // Toggle submenu visibility for VEHICLES
  };
  const toggleOtherMenu = () => {
    setIsOthersOpen(!isOthersOpen); // Toggle submenu visibility for VEHICLES
  };

  const toggleTickethistoryMenu = () => {
    setIsTickethistoryOpen(!isTickethistoryOpen); // Toggle submenu visibility for VEHICLES
  };
  const toggleLeadhistoryMenu = () => {
    setIsLeadhistoryOpen(!isLeadhistoryOpen); // Toggle submenu visibility for VEHICLES
  };
  const toggleJobhistoryMenu = () => {
    setIsJobhistoryOpen(!isJobhistoryOpen); // Toggle submenu visibility for VEHICLES
  };
  const staffRole = localStorage.getItem("staffRole");

  useEffect(() => {
    if (
      pathname == "/login" ||
      pathname == "/forgot-password" ||
      pathname == "/register"
    ) {
      setSidebar("hide");
    } else {
      setSidebar(true);
    }
  }, [pathname]);
  const headerTogglehandle = () => {
    setHeaderToggle(!headerToggle);
    setheaderNavManu(!headerNavManu);
  };
  var body_pd = document.getElementById("body-pd");
  useEffect(() => {
    window.innerWidth >= 768 &&
      (headerToggle
        ? body_pd.classList.add("body-pd")
        : body_pd.classList.remove("body-pd"));
    if (document.getElementById("header") !== null) {
      headerToggle &&
        document.getElementById("header").classList.add("body-pd");
      headerToggle !== true &&
        document.getElementById("header").classList.remove("body-pd");
    }
  }, [headerToggle]);

  const updateActive = () => {
    setRender(!render);
  };

  const logoutHandle = () => {
    Swal.fire({
      icon: "warning",
      title: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("token");
        if (!token) {
          Swal.fire("No token found", "", "error");
          return;
        }
        axios
          .get(
            `${process.env.REACT_APP_BASE_URL}/api/v1/user/logout`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then((response) => {
            if (response.data.success) {
              localStorage.removeItem("token"); // Remove token from local storage
              Swal.fire("Logout Success", "", "success").then(() => {
                window.location.href = "/login"; // Redirect to login page
              });
            } else {
              Swal.fire("Logout Failed", "", "error");
            }
          })
          .catch((error) => {
            Swal.fire("Logout Failed", "", "error");
            console.error("Error during logout:", error);
          });
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  useEffect(() => {
    // Fetch user's email from the backend API
    const fetchEmail = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("No token found");
        }

        const decodedToken = jwtDecode(token);

        const loggedInUserId = decodedToken.id;

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const users = response.data.users;

        // Find the logged-in user's information by matching the ID
        const user = users.find((user) => user._id === loggedInUserId);

        if (user) {
          setEmail(user.email);
        } else {
          console.error("Logged-in user's email not found in response data.");
        }
      } catch (error) {
        console.error("Error fetching user email:", error);
      }
    };

    fetchEmail();
  }, []);

  return (
    <div className={sidebar == "hide" ? "d-none" : ""}>
      <header className="header mb-4 dropdown" id="header">
        <div
          onClick={headerTogglehandle}
          className="header_toggle"
          id="header-toggle"
        >
          {headerNavManu ? (
            <FontAwesomeIcon icon={faBars} />
          ) : (
            <FontAwesomeIcon icon={faX} />
          )}{" "}
        </div>
        <div
          className="d-flex align-items-center dropdown-toggle"
          data-bs-toggle="dropdown"
        >
          <span className="header_img">
            {" "}
            <img src={Admin_icon} alt="admin icon" />{" "}
          </span>{" "}
          <span className="ms-1">{email}</span>{" "}
        </div>

        <ul
          className="dropdown-menu dropdown-menu-end"
          style={{ width: "auto", padding: "0, 2rem" }}
          aria-labelledby="dropdownMenuButton1"
        >
          <li>
            <Link className="dropdown-item" to="/profileSetting">
              Profile
            </Link>
          </li>
          <li>
            <Link className="dropdown-item" to="/general-setting">
              Setting
            </Link>
          </li>
          <li className="dropdown-item" onClick={logoutHandle}>
            Log Out
          </li>
        </ul>
      </header>
      <header
        className="header mb-4 dropdown"
        id="header"
        // style={{ zIndex: 1150 }}
      >
        <div
          onClick={headerTogglehandle}
          className="header_toggle"
          id="header-toggle"
        >
          {headerNavManu ? (
            <FontAwesomeIcon icon={faBars} />
          ) : (
            <FontAwesomeIcon icon={faX} />
          )}
        </div>

        <div
          className="d-flex align-items-center dropdown-toggle"
          data-bs-toggle="dropdown"
          style={{ cursor: "pointer" }}
        >
          <span className="header_img">
            <img src={Admin_icon} alt="admin icon" />
          </span>
          <span className="ms-1">{email}</span>
        </div>

        {/* Updated Dropdown Styles */}
        <ul
          className="dropdown-menu dropdown-menu-end"
          style={{
            width: "auto",
            padding: "0 2rem",
            // position: "absolute",
            top: "100%", // Ensures it drops below the toggle button
            right: 0,
            zIndex: 9999, // Ensures it's above everything
            backgroundColor: "#fff",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)", // Optional shadow for visibility
          }}
          aria-labelledby="dropdownMenuButton1"
        >
          <li>
            <Link className="dropdown-item" to="/profileSetting">
              Profile
            </Link>
          </li>
          <li>
            <Link className="dropdown-item" to="/general-setting">
              Setting
            </Link>
          </li>
          <li className="dropdown-item" onClick={logoutHandle}>
            Log Out
          </li>
        </ul>
      </header>

      <div className="manubar">
        <div className={`l-navbar ${headerToggle ? "show" : " "}`} id="nav-bar">
          <nav className="nav">
            <div>
              {" "}
              <a href="#" className="nav_logo">
                {" "}
                <i className="bx bx-layer nav_logo-icon"></i>{" "}
                <span className="nav_logo-name">Admin Panel</span>{" "}
              </a>
              <div className="nav_list">
                {userRole === "superadmin" && (
                  <>
                    <Link
                      onClick={updateActive}
                      to="/"
                      className={`nav_link ${pathname == "/" ? "active" : ""}`}
                    >
                      <i className="bx bx-grid-alt nav_icon"></i>
                      <span className="nav_name">DASHBOARD</span>
                    </Link>
                    <div className="nav_list">
                      {/* Reports Section */}
                      <div
                        className={`nav_link ${isReportOpen ? "active" : ""}`}
                        onClick={toggleReportMenu}
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon
                          icon={isReportOpen ? faChevronUp : faChevronDown}
                        />
                        <span className="nav_name">
                          <b>REPORTS</b>
                        </span>
                      </div>
                    </div>
                    {/* Submenu links */}
                    {isReportOpen && (
                      <div className="submenu">
                        <Link
                          to="/profitandloss"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/profitandloss" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faUsers} />
                          <span className="nav_name">Profit and Loss</span>
                        </Link>
                        <Link
                          to="/orderreport"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/orderreport" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Hub Reports</span>
                        </Link>

                        <Link
                          to="/ordervehiclereport"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/ordervehiclereport" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faTruck} />
                          <span className="nav_name">Vehicle Reports</span>
                        </Link>

                        <Link
                          to="/orderuserreport"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/orderuserreport" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faUsers} />
                          <span className="nav_name">User Reports</span>
                        </Link>

                        <Link
                          to="/vehiclerevenue"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/vehiclerevenue" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faUsers} />
                          <span className="nav_name">Vehicle Revenue </span>
                        </Link>

                        <Link
                          to="/clientrevenue"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/clientrevenue" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faUsers} />
                          <span className="nav_name">Client Revenue </span>
                        </Link>

                        <Link
                          to="/userrevenue"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/userrevenue" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faUsers} />
                          <span className="nav_name">User Revenue </span>
                        </Link>

                        <Link
                          to="/salaryhistory"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/salaryhistory" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">SALARY History</span>
                        </Link>

                        <Link
                          to="/expensereport"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/expensereport" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faUsers} />
                          <span className="nav_name">Outlay Reports</span>
                        </Link>

                        <Link
                          to="/vehicleutilization"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/vehicleutilization" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faTruck} />
                          <span className="nav_name">
                            Vehicle Utilization R
                          </span>
                        </Link>

                        <Link
                          to="/hubutilization"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/hubutilization" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faTruck} />
                          <span className="nav_name">Hub Utilization R</span>
                        </Link>

                        <Link
                          to="/movingnotmoving"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/movingnotmoving" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Moving/Not-Moving</span>
                        </Link>

                        <Link
                          to="/crossutilization"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/crossutilization" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faPerson} />
                          <span className="nav_name">Cross Utilization</span>
                        </Link>
                      </div>
                    )}
                    <Link
                      to="/vehicle"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname === "/vehicle" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faTruck} />
                      <span className="nav_name">Vehicles</span>
                    </Link>
                    <Link
                      to="/vehiclechallan"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname === "/vehiclechallan" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faTruck} />
                      <span className="nav_name">Vehicle Challan</span>
                    </Link>
                    <Link
                      to="/hub"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/hub" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faWarehouse} />
                      <span className="nav_name">HUBS</span>
                    </Link>
                    <Link
                      to="/client"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/client" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faPersonCircleCheck} />
                      <span className="nav_name">CLIENTS</span>
                    </Link>
                    <Link
                      to="/user"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/user" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faUsers} />
                      <span className="nav_name">USERS</span>
                    </Link>
                    <Link
                      to="/driver"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/driver" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faPerson} />
                      <span className="nav_name">DRIVERS</span>
                    </Link>
                    <Link
                      to="/vendor"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/vendor" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faUserTie} />
                      <span className="nav_name">VENDORS</span>
                    </Link>
                    <Link
                      to="/compliance"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/compliance" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faPerson} />
                      <span className="nav_name">Background VFY</span>
                    </Link>
                    <Link
                      to="/order"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/order" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faClipboardUser} />
                      <span className="nav_name">TRIPS Data</span>
                    </Link>
                    <Link
                      to="/clientorders"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/clientorders" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faClipboardUser} />
                      <span className="nav_name">Route Optimization</span>
                    </Link>
                    <Link
                      to="/defaulter"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/defaulter" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faPeopleRobbery} />
                      <span className="nav_name">DEFAULTERS</span>
                    </Link>
                    <Link
                      to="/payout"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/payout" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faWarehouse} />
                      <span className="nav_name">PAYOUTS</span>
                    </Link>
                    <Link
                      to="/invoice"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/invoice" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faClipboardUser} />
                      <span className="nav_name">INVOICE</span>
                    </Link>
                    <Link
                      to="/consolidated"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/consolidated" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faClipboardUser} />
                      <span className="nav_name">Consolidated</span>
                    </Link>

                    <div
                      className={`nav_link ${
                        isLeadhistoryOpen ? "active" : ""
                      }`}
                      onClick={toggleLeadhistoryMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isLeadhistoryOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">
                        <b>Lead / Customers</b>
                      </span>
                    </div>
                    {/* Submenu links */}
                    {isLeadhistoryOpen && (
                      <>
                        <Link
                          to="/lead"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/lead" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">LEADS / AGENTS</span>
                        </Link>
                        <Link
                          to="/category"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/category" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Business Category</span>
                        </Link>
                      </>
                    )}

                    <div
                      className={`nav_link ${
                        isTickethistoryOpen ? "active" : ""
                      }`}
                      onClick={toggleTickethistoryMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isTickethistoryOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">
                        <b>Ticket</b>
                      </span>
                    </div>
                    {/* Submenu links */}
                    {isTickethistoryOpen && (
                      <>
                        <Link
                          to="/ticket"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/ticket" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">TICKETS</span>
                        </Link>
                        <Link
                          to="/ticketcategory"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/ticketcategory" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Ticket Category</span>
                        </Link>
                      </>
                    )}
                    <div
                      className={`nav_link ${isJobhistoryOpen ? "active" : ""}`}
                      onClick={toggleJobhistoryMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isJobhistoryOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">
                        <b>Hiring Module</b>
                      </span>
                    </div>
                    {/* Submenu links */}
                    {isJobhistoryOpen && (
                      <>
                        <Link
                          to="/job"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/job" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Job Type</span>
                        </Link>
                        <Link
                          to="/candidate"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/candidate" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Applicants Data</span>
                        </Link>
                      </>
                    )}
                    <div
                      className={`nav_link ${
                        isLeasehistoryOpen ? "active" : ""
                      }`}
                      onClick={toggleLeasehistoryMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isLeasehistoryOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">
                        <b>LEASE</b>
                      </span>
                    </div>
                    {/* Submenu links */}
                    {isLeasehistoryOpen && (
                      <>
                        <Link
                          to="/lease"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/lease" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">LEASE</span>
                        </Link>
                        <Link
                          to="/leasehistory"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/leasehistory" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">LEASE History</span>
                        </Link>
                        <Link
                          to="/companysupport"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/companysupport" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name"> Support Table</span>
                        </Link>
                      </>
                    )}
                    <div
                      className={`nav_link ${isLeavesOpen ? "active" : ""}`}
                      onClick={toggleLeavesMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isLeavesOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">LEAVE Management</span>
                    </div>
                    {/* Submenu links */}
                    {isLeavesOpen && (
                      <>
                        <Link
                          onClick={updateActive}
                          to="/leave"
                          className={`nav_link ${
                            pathname == "/leave" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faFaceGrinBeamSweat} />
                          <span className="nav_name">Leaves</span>
                        </Link>
                        <Link
                          to="/leaverestriction"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/leaverestriction" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Leave Restriction</span>
                        </Link>
                        <Link
                          to="/leavetype"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/leavetype" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Leave Type</span>
                        </Link>
                      </>
                    )}
                    <div
                      className={`nav_link ${isSalaryOpen ? "active" : ""}`}
                      onClick={toggleSalaryMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isSalaryOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">SALARY</span>
                    </div>
                    {/* Submenu links */}
                    {isSalaryOpen && (
                      <>
                        <Link
                          to="/salary"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/salary" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">SALARY</span>
                        </Link>
                        <Link
                          to="/salaryhistory"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/salaryhistory" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">SALARY History</span>
                        </Link>
                        <Link
                          to="/salaryapproval"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/salaryapproval" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">SALARY Approval</span>
                        </Link>
                        <Link
                          to="/salaryverification"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/salaryverification" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">SALARY Verification</span>
                        </Link>
                      </>
                    )}
                    <div
                      className={`nav_link ${isVehiclesOpen ? "active" : ""}`}
                      onClick={toggleVehiclesMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isVehiclesOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">REPOSITORY</span>
                    </div>
                    {/* Submenu links */}
                    {isVehiclesOpen && (
                      <>
                        <Link
                          to="/vehicleabovekm"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/vehicleabovekm" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Vehicle Above Km</span>
                        </Link>
                        <Link
                          to="/vehiclenokm"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/vehiclenokm" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Vehicle 0 Km</span>
                        </Link>
                        <Link
                          to="/vehiclenoattendancehistory"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/vehiclenoattendancehistory"
                              ? "active"
                              : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">
                            Vehicle Attendance History
                          </span>
                        </Link>
                        <Link
                          to="/type"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/type" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Vehicle Type</span>
                        </Link>

                        <Link
                          to="/vehicleverification"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/vehicleverification" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Vehicle Audit Type</span>
                        </Link>
                        <Link
                          to="/documenttype"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/documenttype" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Documents Type</span>
                        </Link>

                        <Link
                          to="/insurance"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/insurance" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Documents</span>
                        </Link>

                        <Link
                          to="/vehiclecondition"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/vehiclecondition" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Vehicle Audits</span>
                        </Link>
                        <Link
                          to="/charginglocation"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/charginglocation" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Charging Location </span>
                        </Link>

                        <Link
                          to="/vehiclemaintenance"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/vehiclemaintenance" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Vehicle Maintenance </span>
                        </Link>

                        <Link
                          to="/vehicleonboard"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/vehicleonboard" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">Vehicle On-Board </span>
                        </Link>
                      </>
                    )}
                    <div
                      className={`nav_link ${isStaffOpen ? "active" : ""}`}
                      onClick={toggleStaffMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isStaffOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">
                        <b>GENERAL-STAFF</b>
                      </span>
                    </div>
                    {/* Submenu links */}
                    {isStaffOpen && (
                      <>
                        <Link
                          to="/generalstaff"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/generalstaff" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name"> General Staff</span>
                        </Link>

                        <Link
                          to="/generalstafftype"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/generalstafftype" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">General Staff Type</span>
                        </Link>
                      </>
                    )}
                    <div
                      className={`nav_link ${isDamageOpen ? "active" : ""}`}
                      onClick={toggleDamageMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isDamageOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">DAMAGE</span>
                    </div>
                    {/* Submenu links */}
                    {isDamageOpen && (
                      <>
                        <Link
                          to="/damagecategory"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/damagecategory" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Damage Category</span>
                        </Link>

                        <Link
                          to="/damage"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/damage" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Damages</span>
                        </Link>
                      </>
                    )}
                    <div
                      className={`nav_link ${isExpenseOpen ? "active" : ""}`}
                      onClick={toggleExpenseMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isExpenseOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">Outlay</span>
                    </div>
                    {/* Submenu links */}
                    {isExpenseOpen && (
                      <>
                        <Link
                          to="/expensecategory"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/expensecategory" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Expense Category</span>
                        </Link>

                        <Link
                          to="/expense"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/expense" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Expenses</span>
                        </Link>
                      </>
                    )}
                    <div
                      className={`nav_link ${isAssetsOpen ? "active" : ""}`}
                      onClick={toggleAssetsMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isAssetsOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">ASSETS</span>
                    </div>
                    {/* Submenu links */}
                    {isAssetsOpen && (
                      <>
                        <Link
                          to="/assettype"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/assettype" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Asset Type</span>
                        </Link>

                        <Link
                          to="/asset"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname === "/asset" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Assets</span>
                        </Link>
                      </>
                    )}
                    <div
                      className={`nav_link ${isOthersOpen ? "active" : ""}`}
                      onClick={toggleOtherMenu}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={isOthersOpen ? faChevronUp : faChevronDown}
                      />
                      <span className="nav_name">OTHERS</span>
                    </div>
                    {/* Submenu links */}
                    {isOthersOpen && (
                      <>
                        <Link
                          to="/scrap"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/scrap" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name"> Porter ID</span>
                        </Link>
                        <Link
                          to="/registeration"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/registeration" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Registered Users</span>
                        </Link>
                        <Link
                          to="/hubbucket"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/hubbucket" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name"> Hub Bucket </span>
                        </Link>
                        <Link
                          to="/vehicleinout"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/vehicleinout" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name"> Vehicle In/Out</span>
                        </Link>

                        <Link
                          to="/clientinout"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/clientinout" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name"> Client In/Out</span>
                        </Link>
                        <Link
                          to="/adhoc"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/adhoc" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Adhoc Users</span>
                        </Link>
                        <Link
                          onClick={updateActive}
                          to="/activeinactive"
                          className={`nav_link ${
                            pathname == "/" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faPeopleArrows} />
                          <span className="nav_name">ACTIVE-INACTIVE</span>
                        </Link>
                        <Link
                          onClick={updateActive}
                          to="/activeinactiveusers"
                          className={`nav_link ${
                            pathname == "/" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faPeopleArrows} />
                          <span className="nav_name">Users AC / IAC</span>
                        </Link>

                        <Link
                          to="/hau"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/hau" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">HUB ADMINS</span>
                        </Link>
                        <Link
                          to="/swap"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/swap" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faExchangeAlt} />
                          {/* <FontAwesomeIcon icon={faTruck} /> */}
                          <span className="nav_name">SWAP VEHICLES</span>
                        </Link>
                        <Link
                          to="/advance"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/advance" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faExchangeAlt} />
                          {/* <FontAwesomeIcon icon={faTruck} /> */}
                          <span className="nav_name">ADVANCE Taken</span>
                        </Link>
                        <Link
                          to="/backup"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/backup" ? "active" : ""
                          }`}
                        >
                          {/* <FontAwesomeIcon icon={faTruck} /> */}
                          <FontAwesomeIcon icon={faCircleLeft} />
                          <span className="nav_name">BACKUPS</span>
                        </Link>
                        <Link
                          to="/allusers"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/allusers" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faUsers} />
                          <span className="nav_name">All USERS</span>
                        </Link>
                        <Link
                          to="/attendance"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/attendance" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faWarehouse} />
                          <span className="nav_name">
                            Attendance Consolidated
                          </span>
                        </Link>

                        <Link
                          to="/auditlog"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/auditlog" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faUsers} />
                          <span className="nav_name">Audit Logs</span>
                        </Link>
                        <Link
                          to="/fakelocation"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/fakelocation" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faUsers} />
                          <span className="nav_name">Fake Location</span>
                        </Link>
                        <Link
                          to="/queries"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/queries" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">QUERIES</span>
                        </Link>

                        <Link
                          to="/purgedata"
                          onClick={updateActive}
                          className={`nav_link ${
                            pathname == "/purgedata" ? "active" : ""
                          }`}
                        >
                          <FontAwesomeIcon icon={faClipboardUser} />
                          <span className="nav_name">Purge Data</span>
                        </Link>
                      </>
                    )}
                    <Link onClick={logoutHandle} to="#" className={`nav_link `}>
                      <FontAwesomeIcon icon={faFileInvoice} />
                      <span className="nav_name">LOGOUT</span>
                    </Link>
                  </>
                )}

                {userRole === "admin" && (
                  <>
                    <Link
                      onClick={updateActive}
                      to="/"
                      className={`nav_link ${pathname == "/" ? "active" : ""}`}
                    >
                      <i className="bx bx-grid-alt nav_icon"></i>
                      <span className="nav_name">DASHBOARD</span>
                    </Link>

                    <Link
                      to="/vehicle"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname === "/vehicle" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faTruck} />
                      <span className="nav_name">VEHICLES</span>
                    </Link>
                    <Link
                      to="/driver"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/driver" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faPerson} />
                      <span className="nav_name">DRIVERS</span>
                    </Link>

                    <Link
                      to="/client"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/client" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faPersonCircleCheck} />
                      <span className="nav_name">CLIENTS</span>
                    </Link>

                    <Link
                      to="/user"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/user" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faUsers} />
                      <span className="nav_name">USERS</span>
                    </Link>
                    <Link
                      to="/salaryapproval"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/salaryapproval" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faWarehouse} />
                      <span className="nav_name">SALARY Approval</span>
                    </Link>
                    <Link
                      to="/clientinout"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/clientinout" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faClipboardUser} />
                      <span className="nav_name"> Client In/Out</span>
                    </Link>
                    <Link
                      to="/clientorders"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/clientorders" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faClipboardUser} />
                      <span className="nav_name">CLIENT ORDERS</span>
                    </Link>
                    <Link onClick={logoutHandle} to="#" className={`nav_link `}>
                      <FontAwesomeIcon icon={faFileInvoice} />
                      <span className="nav_name">LOGOUT</span>
                    </Link>
                  </>
                )}

                {userRole === "clientmanager" && (
                  <>
                    <Link
                      onClick={updateActive}
                      to="/"
                      className={`nav_link ${pathname == "/" ? "active" : ""}`}
                    >
                      <i className="bx bx-grid-alt nav_icon"></i>
                      <span className="nav_name">DASHBOARD</span>
                    </Link>
                    <Link
                      to="/vehicle"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname === "/vehicle" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faTruck} />
                      <span className="nav_name">VEHICLES</span>
                    </Link>
                    <Link
                      to="/user"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/user" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faUsers} />
                      <span className="nav_name">USERS</span>
                    </Link>
                    <Link
                      to="/driver"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/driver" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faPerson} />
                      <span className="nav_name">DRIVERS</span>
                    </Link>
                    <Link
                      to="/clientorders"
                      onClick={updateActive}
                      className={`nav_link ${
                        pathname == "/clientorders" ? "active" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faClipboardUser} />
                      <span className="nav_name">Route Optimization</span>
                    </Link>
                    <Link onClick={logoutHandle} to="#" className={`nav_link `}>
                      <FontAwesomeIcon icon={faFileInvoice} />
                      <span className="nav_name">LOGOUT</span>
                    </Link>
                  </>
                )}
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}
